module.exports = __webpack_public_path__ + "img/zgykt_dyh.91964316.jpg";